import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
// import SocialConnectBlock from 'src/components/settings/SocialConnectBlock';
import { ChangePasswordModal } from 'src/components/settings/ChangePasswordModal';
import TwoFactorAuth from 'src/components/settings/TwoFactorAuth';
import { MFA_SETTINGS_ANCHOR } from 'src/constants/userSetting';
import useStyles from './styles';
import { useStore } from 'src/stores';
export const SignInDetailsTab = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const location = useLocation();
  const mfaSectionRef = useRef(null);

  // false: the default first writes emailConfirmed/phoneConfirmed = 'false', and the page's tab handler
  // re-renders PrivateRoute before the response lands, which then redirects to /profile_saved.
  const getProfile = async () => {
    const resp = await store.account.getProfileAsync.run(false);
    return resp;
  };

  // Keyed on the navigation, so the MFA reminder's link scrolls here also when this tab is already open.
  // On first mount this effect runs before the page's tab handler rewrites the query string, which
  // drops the hash, so the hash is still there to read.
  useEffect(() => {
    if (location.hash === "#".concat(MFA_SETTINGS_ANCHOR)) {
      var _mfaSectionRef$curren;
      (_mfaSectionRef$curren = mfaSectionRef.current) === null || _mfaSectionRef$curren === void 0 || _mfaSectionRef$curren.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
  useEffect(() => {
    setIsLoading(true);
    getProfile().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const connectedSocials = ['google', 'linkedin'];

  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWrapper
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.paperBody
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, t('general.change_password')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    marginBottom: "18px"
  }, t('profile_settings.change_password_hint')), /*#__PURE__*/React.createElement(ChangePasswordModal, null))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.lgSection, " ").concat(classes.mfaSection),
    id: MFA_SETTINGS_ANCHOR,
    ref: mfaSectionRef
  }, /*#__PURE__*/React.createElement(Paper, null, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(TwoFactorAuth, null)) : /*#__PURE__*/React.createElement(TwoFactorAuth, null))));
});